import React, { useEffect, useState, useRef } from 'react'
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import SalesDashboardTile from './SalesDashboardTile';
import { useTranslation } from '../../locale/useTranslation';
import * as API from "../../framework/API/api";
import { IMPORT_EXPORT_ACTION, IMPORT_EXPORT_MODULES, IMPORT_EXPORT_STATUS, MAM_STATUS,TOAST_TYPES} from '../../framework/constant/constant';
import { EnumCell } from '../../framework/forms/helpercomponents/CustomGridCells/EnumCell';
import { LocalDateTimeColumn } from '../../framework/forms/helpercomponents/CustomGridCells/DateCell';
import { Link, useNavigate } from 'react-router-dom';
import RoundButton from '../../framework/forms/helpercomponents/buttons/RoundButton';
import MyStatusCell from '../../components/MyStatusCell';
import { utility } from '../../framework/utility/utilityProvider';
import { Info } from '@mui/icons-material';
import BossDialog from '../../components/BossDialog';
import { AuditLogResponse } from '../Audit Log/AuditLogResponse';
import moment from 'moment';
import ActionButton from '../../framework/forms/helpercomponents/buttons/ActionButton';
import ToastNotification from '../../components/ToastNotification';

const ProcessMonitoringDashboard = () => {
  const localSavedDate = utility.getValue('ProcessMonitoringDashboardDate') ?? {}
  const defaultParam = localSavedDate && Object.keys(localSavedDate).length ? localSavedDate : {
    FromDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
    ToDate: moment().format('YYYY-MM-DD')
  };
  const lang = useTranslation();
  const [mamStatusCardsData, setMamStatusCardsData] = useState([]);
  const [logData, setLogData] = useState([]);
  const [showInfoPopup, setShowInfoPopup] = useState(false);
  const [infoData, setInfoData] = useState([]);
  const [showErrorResPreviewPopup, setShowErrorResPreviewPopup] = useState(false);
  const [errorResPreviewData, setErrorResPreviewData] = useState([]);
  const [detailsValue, setDetailsValue] = useState({});
  const navigate = useNavigate();
  const [dataItem, setDataItem] = useState(defaultParam);
  const [showShowImportExportModuleInFullScreen, setShowImportExportModuleInFullScreen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [logDataTileCount, setLogDataTileCount] = useState([]);
  const payloadRef = useRef({});
  const dataItemRef = useRef(defaultParam);
  const dataItemRefSetter = (data) => {
        dataItemRef.current = data;
        setDataItem(data);
    };

  useEffect(() => {
    loadProcessMonitoringDashboardData();
    loadProcessMonitoringDashboardDataCount();
  }, [])

  const loadProcessMonitoringDashboardData = async () => {

    let res = await API.getImportExportDashboardData();
    if (res?.success) {
      console.log(res.data);
      setMamStatusCardsData(res.data.mamStatusCardsData || []);
      setLogData(res.data.importExportLogsData || [])
    }
  };

  const loadProcessMonitoringDashboardDataCount = async () => {
    setIsLoading(true);
    if (isValid()) {
      payloadRef.current = {
        startdate: new Date(dataItemRef.current.FromDate + "T00:00:00").getTime(),
        enddate: new Date(dataItemRef.current.ToDate + "T23:59:59").getTime()
      }
      utility.setValue('ProcessMonitoringDashboardDate', dataItemRef.current);
      let resDataTileCount = await API.getImportExportDashboardDataCount(payloadRef.current);
      console.log("resDataTileCount", resDataTileCount);
      if (resDataTileCount?.success) {
        setIsLoading(false);
        setLogDataTileCount(resDataTileCount.data.importExportLogsData || [])
      }
      else {
        setIsLoading(false);
        ToastNotification({ type: TOAST_TYPES.ERROR, title: "ERROR", message: resDataTileCount.message });
      }
    }
    else {
      setIsLoading(false);
    }
  };

  const onChange = (e) => {
    dataItemRefSetter({ ...dataItem, [e.target.name]: e.target.value });
  }


  const publishStatusData = [
    { platform: "IPTV", done: 40, error: 2, scheduled: 5 },
    { platform: "FuseOTT", done: 55, error: 1, scheduled: 8 },
    { platform: "Playlist", done: 25, error: 2, scheduled: 5 }
  ];

  const recentFilesData = [
    { fileName: "PLAYLIST_12-Nov-2025", type: "VOD", status: "Success", time: "9:50 AM" },
    { fileName: "EPG_12-Nov-2025", type: "EPG", status: "Error", time: "9:20 AM" }
  ];

  const sectionContainerStyle = {
    background: "#ffffff",
    borderRadius: "6px",
    border: "1px solid #e5e7eb",
    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
    padding: "12px",
  };

  const sectionTitleStyle = {
    fontSize: "14px",
    fontWeight: 600,
    color: "#333",
    marginBottom: "6px"
  };

  const dividerStyle = {
    border: "none",
    borderTop: "1px solid #e5e7eb",
    margin: "6px 0 12px 0"
  };

  const getMamStatusUI = (status) => {
    switch (status) {
      case "Pending": return { color: "#64748b", icon: "fa-sharp fa-solid fa-computer", route: `/home/mamAssets?status=${MAM_STATUS.Pending}` };
      case "Ingesting": return { color: "#f59e0b", icon: "fa-sharp fa-solid fa-film", route: `/home/mamAssets?status=${MAM_STATUS.Ingesting}` };
      case "Ingested": return { color: "#06b6d4", icon: "fa-sharp fa-solid fa-compact-disc", route: `/home/mamAssets?status=${MAM_STATUS.Ingested}` };
      case "Transcoding": return { color: "#8b5cf6", icon: "fa-sharp fa-solid fa-peace", route: `/home/mamAssets?status=${MAM_STATUS.Transcoding}` };
      case "TXReady": return { color: "#10b981", icon: "fa-sharp fa-solid fa-cash-register", route: `/home/mamAssets?status=${MAM_STATUS.TXReady}` };
      default: return { color: "#3b82f6", icon: "fa-sharp fa-solid fa-podcast", route: "/home/mamAssets" };
    }
  };

  const getFileProcessingStats = (data, moduleId) => {
    const files = data?.[moduleId]?.files || [];
    return files.reduce(
      (acc, file) => {
        switch (file.FileProcessingStatus) {
          case IMPORT_EXPORT_STATUS.Success:
            acc.Success++;
            break;
          case IMPORT_EXPORT_STATUS.Failed:
            acc.Failed++;
            break;
          case IMPORT_EXPORT_STATUS.Processing:
            acc.Processing++;
            break;
          case IMPORT_EXPORT_STATUS["Validation Failed"]:
            acc.ValidationFailed++;
            break;
        }
        return acc;
      },
      { Success: 0, Failed: 0, Processing: 0, ValidationFailed: 0 }
    );
  };

  const Mystatuscell = (props) => {
    const { dataItem } = props;

    let title = "";
    let tileBackColor = "";

    const status = dataItem?.FileProcessingStatus;
    if (status === IMPORT_EXPORT_STATUS.Failed) {
      title = utility.getKeyByValue(IMPORT_EXPORT_STATUS, status);
      tileBackColor = "#FF0000";
    } else if (status === IMPORT_EXPORT_STATUS.Processing) {
      title = utility.getKeyByValue(IMPORT_EXPORT_STATUS, status);
      tileBackColor = "#fd7e14";
    } else if (status === IMPORT_EXPORT_STATUS.Success) {
      title = utility.getKeyByValue(IMPORT_EXPORT_STATUS, status);
      tileBackColor = "#28a745";
    }

    return (
      <MyStatusCell {...props} title={title} tileBackColor={tileBackColor} />
    );
  };

  const StatusCellWithCount = ({ title = "Status", count = 0, color = "#28a745", onClick = () => { } }) => (
    <span
      onClick={onClick}
      style={{ backgroundColor: color, color: "#fff", padding: "3px 8px", borderRadius: "4px", fontSize: "13px", fontWeight: 500, cursor: "pointer", whiteSpace: "nowrap", }}
    >
      {title} : {count}
    </span>
  );

  const epgProcessingStats = getFileProcessingStats(logDataTileCount, IMPORT_EXPORT_MODULES.EPG_IMPORT);
  const vodProcessingStats = getFileProcessingStats(logDataTileCount, IMPORT_EXPORT_MODULES.VOD_IMPORT);
  const epgImportData = logData?.[IMPORT_EXPORT_MODULES.EPG_IMPORT]?.files || [];
  const epgExportData = logData?.[IMPORT_EXPORT_MODULES.EPG_EXPORT]?.files || [];
  const vodImporData = logData?.[IMPORT_EXPORT_MODULES.VOD_IMPORT]?.files || [];
  const vodExportData = logData?.[IMPORT_EXPORT_MODULES.VOD_EXPORT]?.files || [];
  const workOrderImportData = logData?.[IMPORT_EXPORT_MODULES.MAM_WO_IMPORT]?.files || [];
  const workOrderExportData = logData?.[IMPORT_EXPORT_MODULES.MAM_WO_EXPORT]?.files || [];
  const scheduleExportData = logData?.[IMPORT_EXPORT_MODULES.SCHEDULE_EXPORT]?.files || [];
  const scheduleExportStats = getFileProcessingStats(logData, IMPORT_EXPORT_MODULES.SCHEDULE_EXPORT);

  const workOrderExportStats = {
    MAM_WO_EXPORT_INGEST_STATUS: logData?.[IMPORT_EXPORT_MODULES.MAM_WO_EXPORT]?.IngestCount ?? 0,
    MAM_WO_EXPORT_TRANSCODE_STATUS: logData?.[IMPORT_EXPORT_MODULES.MAM_WO_EXPORT]?.TranscodeCount ?? 0
  };

  const workOrderImportStats = {
    MAM_WO_IMPORT_INGEST_STATUS: logData?.[IMPORT_EXPORT_MODULES.MAM_WO_IMPORT]?.IngestCount ?? 0,
    MAM_WO_IMPORT_TRANSCODE_STATUS: logData?.[IMPORT_EXPORT_MODULES.MAM_WO_IMPORT]?.TranscodeCount ?? 0
  };

  const InfoCell = (props) => {
    return (
      <td style={{ textAlign: "center" }}>
        <Info
          sx={{ color: "#0d6efd", fontSize: 26, cursor: "pointer", fontWeight: "bold" }}
          onClick={() => { setInfoData(props?.dataItem?.History || []); setShowInfoPopup(true); }}
        />
      </td>
    );
  };

  const ErrorResPreviewCell = (props) => {
    return (
      <td style={{ textAlign: "center" }}>
        <RoundButton
          icon={"eye"}
          title={"Error Preview"}
          onClick={() => handleShowErrorResPreview(props.dataItem)}
        />
      </td>
    );
  };

  const handleShowErrorResPreview = (item) => {

    const formattedErrors = (item?.ErrorRes || []).map(err => ({
      success: err.success,
      message: err.message
    }));
    setErrorResPreviewData(formattedErrors);
    setDetailsValue({
      Event: item?.Filename,
      User: item?.FileProcessingStatus,
      EntryDateTime: moment(item?.UpdatedOn).format('YYYY-MM-DD HH:mm:ss')
    });
    setShowErrorResPreviewPopup(true);
  }

  const onCloseErrorResPreview = () => {
    setShowErrorResPreviewPopup(false);
    setErrorResPreviewData([]);
  }
  const isValid = () => {
    if (!utility.isValidDate(dataItemRef.current.FromDate)) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_from_date_error_message });
      return false;
    }
    if (!utility.isValidDate(dataItemRef.current.ToDate)) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_to_date_error_message });
      return false;
    }
    if (dataItemRef.current.FromDate > dataItemRef.current.ToDate) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.from_date_should_be_less_than_to_date_error_message });
      return false;
    }
    return true;
  }

  const importExportModuleWiseCount = Object.entries(IMPORT_EXPORT_MODULES).map(([key, value]) => {
    const stats = getFileProcessingStats(logDataTileCount, value);
    return {
      Module: key,
      ModuleId: value,
      Success: stats.Success,
      Failed: stats.Failed,
      Processing: stats.Processing,
      ValidationFailed: stats.ValidationFailed
    };
  });

  const NevigateLogBrowserCell = (props) => {
    const value = props.dataItem?.[props.field] ?? 0;
    const Status = props.field === "ValidationFailed" ? IMPORT_EXPORT_STATUS["Validation Failed"] : IMPORT_EXPORT_STATUS[props.field];
    return (
      <td colSpan={props.colSpan} role="gridcell" aria-colindex={props.ariaColumnIndex} aria-selected={props.isSelected}
        {...props.tdProps} title={props.tooltip}
        onClick={(e) => {
          e.stopPropagation();
          if (value) { navigate(`/home/logBrowser?Module=${props.dataItem.ModuleId}&FileProcessingStatus=${Status}&FromDate=${dataItemRef.current.FromDate}&ToDate=${dataItemRef.current.ToDate}`); }
        }}
        style={{ cursor: value ? "pointer" : "default", color: value ? "#0d6efd" : "#6c757d", textDecoration: value ? "underline" : "none", fontWeight: 500 }}>
        <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", padding: "6px 8px", boxSizing: "border-box" }}> {value} </div>
      </td>
    );
  };

  return (<>
    <div className="row form-group ml-2">
      <div className="col-3">
        <label htmlFor="">{lang.from_date_label} </label>
        <input type="date" className="form-control form-control-sm" name="FromDate" value={dataItem.FromDate} onChange={onChange} />
      </div>
      <div className="col-3">
        <label htmlFor="">{lang.to_date_label} </label>
        <input type="date" className="form-control form-control-sm" name="ToDate" value={dataItem.ToDate} onChange={onChange} />
      </div>
      <div className="col" style={{ textAlign: "left", marginTop: "20px" }}>
        <ActionButton title={lang.show_button_tooltip} name={ isLoading ? ( <> <span className="spinner-border spinner-border-sm"></span> Loading... </> ) : ( lang.show_button_text )} onClick={loadProcessMonitoringDashboardDataCount} />
      </div>
    </div>

    <div className="container-fluid">
      <div style={{ display: "flex", gap: "20px", marginBottom: "1rem" }}>
        <div style={{ flex: 1, ...sectionContainerStyle }}>
          <div style={sectionTitleStyle}>EPG Import Processing</div>
          <hr style={dividerStyle} />
          <div style={{ display: "flex", gap: "12px" }}>
            {/* Success Tile */}
            <Link
              to={`/home/logBrowser?Module=${IMPORT_EXPORT_MODULES.EPG_IMPORT}&FileProcessingStatus=${IMPORT_EXPORT_STATUS.Success}&FromDate=${dataItemRef.current.FromDate}&ToDate=${dataItemRef.current.ToDate}`}
              style={{ flex: 1, textDecoration: "none" }}
            >
              <div style={{
                background: "linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)",
                borderRadius: "12px",
                padding: "16px",
                border: "1px solid #bbf7d0",
                boxShadow: "0 2px 8px rgba(34, 197, 94, 0.1)",
                transition: "all 0.3s ease",
                cursor: "pointer",
                minHeight: "100px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(34, 197, 94, 0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 2px 8px rgba(34, 197, 94, 0.1)";
                }}
              >
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  color: "#15803d",
                  fontSize: "13px",
                  fontWeight: "500",
                  marginBottom: "8px"
                }}>
                  <i className="fa fa-check-circle" style={{ fontSize: "14px" }} />
                  <span>Successful</span>
                </div>
                <div style={{
                  fontSize: "32px",
                  fontWeight: "700",
                  color: "#166534",
                  lineHeight: 1
                }}>
                  {epgProcessingStats.Success}
                </div>
              </div>
            </Link>

            {/* Failed Tile */}
            <Link
              to={`/home/logBrowser?Module=${IMPORT_EXPORT_MODULES.EPG_IMPORT}&FileProcessingStatus=${IMPORT_EXPORT_STATUS.Failed}&FromDate=${dataItemRef.current.FromDate}&ToDate=${dataItemRef.current.ToDate}`}
              style={{ flex: 1, textDecoration: "none" }}
            >
              <div style={{
                background: "linear-gradient(135deg, #fef2f2 0%, #fecaca 100%)",
                borderRadius: "12px",
                padding: "16px",
                border: "1px solid #fca5a5",
                boxShadow: "0 2px 8px rgba(239, 68, 68, 0.1)",
                transition: "all 0.3s ease",
                cursor: "pointer",
                minHeight: "100px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(239, 68, 68, 0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 2px 8px rgba(239, 68, 68, 0.1)";
                }}
              >
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  color: "#dc2626",
                  fontSize: "13px",
                  fontWeight: "500",
                  marginBottom: "8px"
                }}>
                  <i className="fa fa-exclamation-triangle" style={{ fontSize: "14px" }} />
                  <span>Failed</span>
                </div>
                <div style={{
                  fontSize: "32px",
                  fontWeight: "700",
                  color: "#b91c1c",
                  lineHeight: 1
                }}>
                  {epgProcessingStats.Failed}
                </div>
              </div>
            </Link>

            {/* Processing Tile */}
            <Link
              to={`/home/logBrowser?Module=${IMPORT_EXPORT_MODULES.EPG_IMPORT}&FileProcessingStatus=${IMPORT_EXPORT_STATUS.Processing}&FromDate=${dataItemRef.current.FromDate}&ToDate=${dataItemRef.current.ToDate}`}
              style={{ flex: 1, textDecoration: "none" }}
            >
              <div style={{
                background: "linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)",
                borderRadius: "12px",
                padding: "16px",
                border: "1px solid #fde68a",
                boxShadow: "0 2px 8px rgba(245, 158, 11, 0.1)",
                transition: "all 0.3s ease",
                cursor: "pointer",
                minHeight: "100px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(245, 158, 11, 0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 2px 8px rgba(245, 158, 11, 0.1)";
                }}
              >
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  color: "#d97706",
                  fontSize: "13px",
                  fontWeight: "500",
                  marginBottom: "8px"
                }}>
                  <i className="fa fa-spinner fa-spin" style={{ fontSize: "14px" }} />
                  <span>Processing</span>
                </div>
                <div style={{
                  fontSize: "32px",
                  fontWeight: "700",
                  color: "#b45309",
                  lineHeight: 1
                }}>
                  {epgProcessingStats.Processing}
                </div>
              </div>
            </Link>
            {/* Validation Failed */}
            <Link
              to={`/home/logBrowser?Module=${IMPORT_EXPORT_MODULES.EPG_IMPORT}&FileProcessingStatus=${IMPORT_EXPORT_STATUS['Validation Failed']}&FromDate=${dataItemRef.current.FromDate}&ToDate=${dataItemRef.current.ToDate}`}
              style={{ flex: 1, textDecoration: "none" }}
            >
              <div style={{
                background: "linear-gradient(135deg, #fff4e6 0%, #ffd8a8 100%)",
                borderRadius: "12px",
                padding: "16px",
                border: "1px solid  #fd7e14",
                boxShadow: "0 2px 8px rgba(245, 158, 11, 0.1)",
                transition: "all 0.3s ease",
                cursor: "pointer",
                minHeight: "100px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(245, 158, 11, 0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 2px 8px rgba(245, 158, 11, 0.1)";
                }}
              >
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  color: "#fd7e14",
                  fontSize: "13px",
                  fontWeight: "500",
                  marginBottom: "8px"
                }}>
                  <i className="fa fa-exclamation-circle" style={{ color: "#fd7e14", fontSize: "14px" }} />
                  <span>Valid Failed</span>
                </div>
                <div style={{
                  fontSize: "32px",
                  fontWeight: "700",
                  color: "#e8590c",
                  lineHeight: 1
                }}>
                  {epgProcessingStats.ValidationFailed}
                </div>
              </div>
            </Link>
          </div>
        </div>
        <div style={{ flex: 1, ...sectionContainerStyle }}>
          <div style={sectionTitleStyle}>VOD Metadata Import Processing</div>
          <hr style={dividerStyle} />
          <div style={{ display: "flex", gap: "12px" }}>
            {/* Success Tile */}
            <Link
              to={`/home/logBrowser?Module=${IMPORT_EXPORT_MODULES.VOD_IMPORT}&FileProcessingStatus=${IMPORT_EXPORT_STATUS.Success}&FromDate=${dataItemRef.current.FromDate}&ToDate=${dataItemRef.current.ToDate}`}
              style={{ flex: 1, textDecoration: "none" }}
            >
              <div style={{
                background: "linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)",
                borderRadius: "12px",
                padding: "16px",
                border: "1px solid #bbf7d0",
                boxShadow: "0 2px 8px rgba(34, 197, 94, 0.1)",
                transition: "all 0.3s ease",
                cursor: "pointer",
                minHeight: "100px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(34, 197, 94, 0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 2px 8px rgba(34, 197, 94, 0.1)";
                }}
              >
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  color: "#15803d",
                  fontSize: "13px",
                  fontWeight: "500",
                  marginBottom: "8px"
                }}>
                  <i className="fa fa-check-circle" style={{ fontSize: "14px" }} />
                  <span>Success</span>
                </div>
                <div style={{
                  fontSize: "32px",
                  fontWeight: "700",
                  color: "#166534",
                  lineHeight: 1
                }}>
                  {vodProcessingStats.Success}
                </div>
              </div>
            </Link>

            {/* Failed Tile */}
            <Link
              to={`/home/logBrowser?Module=${IMPORT_EXPORT_MODULES.VOD_IMPORT}&FileProcessingStatus=${IMPORT_EXPORT_STATUS.Failed}&FromDate=${dataItemRef.current.FromDate}&ToDate=${dataItemRef.current.ToDate}`}
              style={{ flex: 1, textDecoration: "none" }}
            >
              <div style={{
                background: "linear-gradient(135deg, #fef2f2 0%, #fecaca 100%)",
                borderRadius: "12px",
                padding: "16px",
                border: "1px solid #fca5a5",
                boxShadow: "0 2px 8px rgba(239, 68, 68, 0.1)",
                transition: "all 0.3s ease",
                cursor: "pointer",
                minHeight: "100px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(239, 68, 68, 0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 2px 8px rgba(239, 68, 68, 0.1)";
                }}
              >
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  color: "#dc2626",
                  fontSize: "13px",
                  fontWeight: "500",
                  marginBottom: "8px"
                }}>
                  <i className="fa fa-exclamation-triangle" style={{ fontSize: "14px" }} />
                  <span>Failed</span>
                </div>
                <div style={{
                  fontSize: "32px",
                  fontWeight: "700",
                  color: "#b91c1c",
                  lineHeight: 1
                }}>
                  {vodProcessingStats.Failed}
                </div>
              </div>
            </Link>

            {/* Processing Tile */}
            <Link
              to={`/home/logBrowser?Module=${IMPORT_EXPORT_MODULES.VOD_IMPORT}&FileProcessingStatus=${IMPORT_EXPORT_STATUS.Processing}&FromDate=${dataItemRef.current.FromDate}&ToDate=${dataItemRef.current.ToDate}`}
              style={{ flex: 1, textDecoration: "none" }}
            >
              <div style={{
                background: "linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)",
                borderRadius: "12px",
                padding: "16px",
                border: "1px solid #fde68a",
                boxShadow: "0 2px 8px rgba(245, 158, 11, 0.1)",
                transition: "all 0.3s ease",
                cursor: "pointer",
                minHeight: "100px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(245, 158, 11, 0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 2px 8px rgba(245, 158, 11, 0.1)";
                }}
              >
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  color: "#d97706",
                  fontSize: "13px",
                  fontWeight: "500",
                  marginBottom: "8px"
                }}>
                  <i className="fa fa-spinner fa-spin" style={{ fontSize: "14px" }} />
                  <span>Processing</span>
                </div>
                <div style={{
                  fontSize: "32px",
                  fontWeight: "700",
                  color: "#b45309",
                  lineHeight: 1
                }}>
                  {vodProcessingStats.Processing}
                </div>
              </div>
            </Link>
             {/* Processing Tile */}
            <Link
              to={`/home/logBrowser?Module=${IMPORT_EXPORT_MODULES.VOD_IMPORT}&FileProcessingStatus=${IMPORT_EXPORT_STATUS['Validation Failed']}&FromDate=${dataItemRef.current.FromDate}&ToDate=${dataItemRef.current.ToDate}`}
              style={{ flex: 1, textDecoration: "none" }}
            >
              <div style={{
                background: "linear-gradient(135deg, #fff4e6 0%, #ffd8a8 100%)",
                borderRadius: "12px",
                padding: "16px",
                border: "1px solid  #fd7e14",
                boxShadow: "0 2px 8px rgba(245, 158, 11, 0.1)",
                transition: "all 0.3s ease",
                cursor: "pointer",
                minHeight: "100px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(245, 158, 11, 0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 2px 8px rgba(245, 158, 11, 0.1)";
                }}
              >
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  color: "#fd7e14",
                  fontSize: "13px",
                  fontWeight: "500",
                  marginBottom: "8px"
                }}>
                  <i className="fa fa-exclamation-circle" style={{ color: "#fd7e14", fontSize: "14px" }} />
                  <span>Valid Failed</span>
                </div>
                <div style={{
                  fontSize: "32px",
                  fontWeight: "700",
                  color: "#e8590c",
                  lineHeight: 1
                }}>
                  {vodProcessingStats.ValidationFailed}
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-lg-6">
          <div style={sectionContainerStyle}>
            <div style={{ ...sectionTitleStyle, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span>{lang.epg_import_label}</span>
              <RoundButton icon="arrow-right" title="View Filtered" btnColor="white" onClick={() => navigate(`/home/logBrowser?Module=${IMPORT_EXPORT_MODULES.EPG_IMPORT}`)} />
            </div>
            <hr style={dividerStyle} />
            <Grid data={epgImportData} style={{ height: "220px", width: "100%", overflowY: "auto" }}>
              <Column width={"120px"} field="FileProcessingStatus" title="Status" cell={Mystatuscell} />
              <Column width="65px" title="Info" cell={InfoCell} />
              <Column width="75px" title="Error Res" cell={ErrorResPreviewCell} />
              <Column width="150px" field="Action" title="Action" cell={EnumCell} />
              <Column field="Filename" title="File Name" />
              <Column width={'200px'} field="AddOn" title="Time" cell={LocalDateTimeColumn} />
            </Grid>
          </div>
        </div>
        <div className="col-lg-6">
          <div style={sectionContainerStyle}>
            <div style={{ ...sectionTitleStyle, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span>{lang.vod_import_label}</span>
              <RoundButton icon="arrow-right" title="View Filtered" btnColor="white" onClick={() => navigate(`/home/logBrowser?Module=${IMPORT_EXPORT_MODULES.VOD_IMPORT}`)} />
            </div>
            <hr style={dividerStyle} />
            <Grid data={vodImporData} style={{ height: "220px", width: "100%", overflowY: "auto" }}>
              <Column width={"120px"} field="FileProcessingStatus" title="Status" cell={Mystatuscell} />
              <Column width="65px" title="Info" cell={InfoCell} />
              <Column width="75px" title="Error Res" cell={ErrorResPreviewCell} />
              <Column width="150px" field="Action" title="Action" cell={EnumCell} />
              <Column field="Filename" title="File Name" />
              <Column width={'200px'} field="AddOn" title="Time" cell={LocalDateTimeColumn} />
            </Grid>
          </div>
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-lg-6">
          <div style={sectionContainerStyle}>
            <div style={{ ...sectionTitleStyle, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span>{lang.epg_export_label}</span>
              <RoundButton icon="arrow-right" title="View Filtered" btnColor="white" onClick={() => navigate(`/home/logBrowser?Module=${IMPORT_EXPORT_MODULES.EPG_EXPORT}`)} />
            </div>
            <hr style={dividerStyle} />
            <Grid data={epgExportData} style={{ height: "220px", width: "100%", overflowY: "auto" }}>
              <Column width={"120px"} field="FileProcessingStatus" title="Status" cell={Mystatuscell} />
              <Column width="65px" title="Info" cell={InfoCell} />
              <Column width="75px" title="Error Res" cell={ErrorResPreviewCell} />
              <Column width="220px" field="Action" title="Action" cell={EnumCell} />
              <Column field="Filename" title="File Name" />
              <Column width={'200px'} field="AddOn" title="Time" cell={LocalDateTimeColumn} />
            </Grid>
          </div>
        </div>
        <div className="col-lg-6">
          <div style={sectionContainerStyle}>
            <div style={{ ...sectionTitleStyle, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span>{lang.vod_export_label}</span>
              <RoundButton icon="arrow-right" title="View Filtered" btnColor="white" onClick={() => navigate(`/home/logBrowser?Module=${IMPORT_EXPORT_MODULES.VOD_EXPORT}`)} />
            </div>
            <hr style={dividerStyle} />
            <Grid data={vodExportData} style={{ height: "220px", width: "100%", overflowY: "auto" }}>
              <Column width={"120px"} field="FileProcessingStatus" title="Status" cell={Mystatuscell} />
              <Column width="65px" title="Info" cell={InfoCell} />
              <Column width="75px" title="Error Res" cell={ErrorResPreviewCell} />
              <Column width="220px" field="Action" title="Action" cell={EnumCell} />
              <Column field="Filename" title="File Name" />
              <Column width={'200px'} field="AddOn" title="Time" cell={LocalDateTimeColumn} />
            </Grid>
          </div>
        </div>
      </div>
      <div style={{ display: "flex", gap: "20px", marginBottom: "1rem" }}>
        <div style={{ flex: 1, ...sectionContainerStyle }}>
          <div style={sectionTitleStyle}>Work Order Import Processing</div>
          <hr style={dividerStyle} />
          <div style={{ display: "flex", gap: "12px" }}>
            <Link to={`/home/logBrowser?Module=${IMPORT_EXPORT_MODULES.MAM_WO_IMPORT}&Action=${IMPORT_EXPORT_ACTION.MAM_WO_IMPORT_INGEST_STATUS}`} style={{ flex: 1, textDecoration: "none" }}>
              <div
                style={{
                  background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
                  borderRadius: "12px",
                  padding: "16px",
                  border: "1px solid #bfdbfe",
                  boxShadow: "0 2px 8px rgba(59, 130, 246, 0.1)",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                  minHeight: "100px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(59, 130, 246, 0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 2px 8px rgba(59, 130, 246, 0.1)";
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    color: "#1d4ed8",
                    fontSize: "13px",
                    fontWeight: "500",
                    marginBottom: "8px",
                  }}
                >
                  <i className="fa fa-download" style={{ fontSize: "14px" }} />
                  <span>WO Import : Ingest</span>
                </div>

                <div
                  style={{
                    fontSize: "32px",
                    fontWeight: "700",
                    color: "#1e40af",
                    lineHeight: 1,
                  }}
                >
                  {workOrderImportStats.MAM_WO_IMPORT_INGEST_STATUS}
                </div>
              </div>
            </Link>
            <Link to={`/home/logBrowser?Module=${IMPORT_EXPORT_MODULES.MAM_WO_IMPORT}&Action=${IMPORT_EXPORT_ACTION.MAM_WO_IMPORT_TRANSCODE_STATUS}`} style={{ flex: 1, textDecoration: "none" }} >
              <div
                style={{
                  background: "linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%)",
                  borderRadius: "12px",
                  padding: "16px",
                  border: "1px solid #ddd6fe",
                  boxShadow: "0 2px 8px rgba(139, 92, 246, 0.1)",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                  minHeight: "100px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(139, 92, 246, 0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 2px 8px rgba(139, 92, 246, 0.1)";
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    color: "#6d28d9",
                    fontSize: "13px",
                    fontWeight: "500",
                    marginBottom: "8px",
                  }}
                >
                  <i className="fa fa-cogs" style={{ fontSize: "14px" }} />
                  <span>WO Import : Transcode</span>
                </div>

                <div
                  style={{
                    fontSize: "32px",
                    fontWeight: "700",
                    color: "#5b21b6",
                    lineHeight: 1,
                  }}
                >
                  {workOrderImportStats.MAM_WO_IMPORT_TRANSCODE_STATUS}
                </div>
              </div>
            </Link>
          </div>
        </div>
        <div style={{ flex: 1, ...sectionContainerStyle }}>
          <div style={sectionTitleStyle}>Work Order Export Processing</div>
          <hr style={dividerStyle} />
          <div style={{ display: "flex", gap: "12px" }}>
            <Link to={`/home/logBrowser?Module=${IMPORT_EXPORT_MODULES.MAM_WO_EXPORT}&Action=${IMPORT_EXPORT_ACTION.MAM_WO_EXPORT_INGEST}`} style={{ flex: 1, textDecoration: "none" }}>
              <div
                style={{
                  background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
                  borderRadius: "12px",
                  padding: "16px",
                  border: "1px solid #bfdbfe",
                  boxShadow: "0 2px 8px rgba(59, 130, 246, 0.1)",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                  minHeight: "100px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(59, 130, 246, 0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 2px 8px rgba(59, 130, 246, 0.1)";
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    color: "#1d4ed8",
                    fontSize: "13px",
                    fontWeight: "500",
                    marginBottom: "8px",
                  }}
                >
                  <i className="fa fa-download" style={{ fontSize: "14px" }} />
                  <span>WO Export : Ingest</span>
                </div>

                <div
                  style={{
                    fontSize: "32px",
                    fontWeight: "700",
                    color: "#1e40af",
                    lineHeight: 1,
                  }}
                >
                  {workOrderExportStats.MAM_WO_EXPORT_INGEST_STATUS}
                </div>
              </div>
            </Link>
            <Link to={`/home/logBrowser?Module=${IMPORT_EXPORT_MODULES.MAM_WO_EXPORT}&Action=${IMPORT_EXPORT_ACTION.MAM_WO_EXPORT_TRANSCODE}`} style={{ flex: 1, textDecoration: "none" }}>
              <div
                style={{
                  background: "linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%)",
                  borderRadius: "12px",
                  padding: "16px",
                  border: "1px solid #ddd6fe",
                  boxShadow: "0 2px 8px rgba(139, 92, 246, 0.1)",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                  minHeight: "100px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(139, 92, 246, 0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 2px 8px rgba(139, 92, 246, 0.1)";
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    color: "#6d28d9",
                    fontSize: "13px",
                    fontWeight: "500",
                    marginBottom: "8px",
                  }}
                >
                  <i className="fa fa-cogs" style={{ fontSize: "14px" }} />
                  <span>WO Export : Transcode</span>
                </div>

                <div
                  style={{
                    fontSize: "32px",
                    fontWeight: "700",
                    color: "#5b21b6",
                    lineHeight: 1,
                  }}
                >
                  {workOrderExportStats.MAM_WO_EXPORT_TRANSCODE_STATUS}
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-lg-6">
          <div style={sectionContainerStyle}>
            <div style={{ ...sectionTitleStyle, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span>{lang.work_order_import_label}</span>
              <RoundButton icon="arrow-right" title="View Filtered" btnColor="white" onClick={() => navigate(`/home/logBrowser?Module=${IMPORT_EXPORT_MODULES.MAM_WO_IMPORT}`)} />
            </div>
            <hr style={dividerStyle} />
            <Grid data={workOrderImportData} style={{ height: "220px", width: "100%", overflowY: "auto" }}>
              <Column width={"120px"} field="FileProcessingStatus" title="Status" cell={Mystatuscell} />
              <Column width="65px" title="Info" cell={InfoCell} />
              <Column width="75px" title="Error Res" cell={ErrorResPreviewCell} />
              <Column width="220px" field="Action" title="Action" cell={EnumCell} />
              <Column field="Filename" title="File Name" />
              <Column width={'200px'} field="AddOn" title="Time" cell={LocalDateTimeColumn} />
            </Grid>
          </div>
        </div>
        <div className="col-lg-6">
          <div style={sectionContainerStyle}>
            <div style={{ ...sectionTitleStyle, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span>{lang.work_order_export_label}</span>
              <RoundButton icon="arrow-right" title="View Filtered" btnColor="white" onClick={() => navigate(`/home/logBrowser?Module=${IMPORT_EXPORT_MODULES.MAM_WO_EXPORT}`)} />
            </div>
            <hr style={dividerStyle} />
            <Grid data={workOrderExportData} style={{ height: "220px", overflowY: "auto" }}>
              <Column width={"120px"} field="FileProcessingStatus" title="Status" cell={Mystatuscell} />
              <Column width="65px" title="Info" cell={InfoCell} />
              <Column width="75px" title="Error Res" cell={ErrorResPreviewCell} />
              <Column width="220px" field="Action" title="Action" cell={EnumCell} />
              <Column field="Filename" title="File Name" />
              <Column width={'200px'} field="AddOn" title="Time" cell={LocalDateTimeColumn} />
            </Grid>
          </div>
        </div>
      </div>
      <div className="row mb-5">
        <div className="col-lg-6">
          <div style={sectionContainerStyle}>
            <div style={{ ...sectionTitleStyle, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span>{lang.schedule_export_label}</span>
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <StatusCellWithCount
                  title="Success"
                  count={scheduleExportStats.Success}
                  color="#28a745"
                  onClick={() => navigate(`/home/logBrowser?Module=${IMPORT_EXPORT_MODULES.SCHEDULE_EXPORT}&FileProcessingStatus=${IMPORT_EXPORT_STATUS.Success}`)} />
                <StatusCellWithCount
                  title="Failed"
                  count={scheduleExportStats.Failed}
                  color="#FF0000"
                  onClick={() => navigate(`/home/logBrowser?Module=${IMPORT_EXPORT_MODULES.SCHEDULE_EXPORT}&FileProcessingStatus=${IMPORT_EXPORT_STATUS.Failed}`)} />
                <StatusCellWithCount
                  title="Processing"
                  count={scheduleExportStats.Processing}
                  color="#fd7e14"
                  onClick={() => navigate(`/home/logBrowser?Module=${IMPORT_EXPORT_MODULES.SCHEDULE_EXPORT}&FileProcessingStatus=${IMPORT_EXPORT_STATUS.Processing}`)} />
                <RoundButton icon="arrow-right" title="View Filtered" btnColor="white" onClick={() => navigate(`/home/logBrowser?Module=${IMPORT_EXPORT_MODULES.SCHEDULE_EXPORT}`)} />
              </div>
            </div>
            <hr style={dividerStyle} />
            <Grid data={scheduleExportData} style={{ height: "220px", width: "100%", overflowY: "auto" }}>
              <Column width={"120px"} field="FileProcessingStatus" title="Status" cell={Mystatuscell} />
              <Column width="65px" title="Info" cell={InfoCell} />
              <Column width="75px" title="Error Res" cell={ErrorResPreviewCell} />
              <Column width="220px" field="Action" title="Action" cell={EnumCell} />
              <Column field="Filename" title="File Name" />
              <Column width={'200px'} field="AddOn" title="Time" cell={LocalDateTimeColumn} />
            </Grid>
          </div>
        </div>
        <div className="col-lg-6">
          <div style={sectionContainerStyle}>
            <div style={{ ...sectionTitleStyle, display: "flex", alignItems: "center" }}>
              <span>{lang.import_export_module_wise_count_label}</span>
              <div style={{ marginLeft: "auto", display: "flex", gap: "8px" }}>
                <RoundButton icon="expand" title={lang.show_import_export_module_wise_full_screen_button_tooltip} onClick={() => setShowImportExportModuleInFullScreen(!showShowImportExportModuleInFullScreen)} />
                <RoundButton icon="arrow-right" title={`${lang.import_export_module_wise_count_label} View Filtered`} btnColor="white" onClick={() => navigate(`/home/logBrowser?Module=${IMPORT_EXPORT_MODULES.EPG_IMPORT}`)} />
              </div>
            </div>
            <hr style={dividerStyle} />
            <Grid data={importExportModuleWiseCount} style={{ height: "220px", width: "100%", overflowY: "auto" }}>
              <Column width="180px" field="Module" title="Module" />
              <Column width="100px" field="Success" title="Success" cell={NevigateLogBrowserCell} />
              <Column width="100px" field="Failed" title="Failed" cell={NevigateLogBrowserCell} />
              <Column width="120px" field="Processing" title="Processing" cell={NevigateLogBrowserCell} />
              <Column width="150px" field="ValidationFailed" title="Validation Failed" cell={NevigateLogBrowserCell} />
              <Column width="100px" title="Action" cell={NevigateLogBrowserCell} />
            </Grid>
          </div>
        </div>
        {/* <div className="col-lg-6">
          <div style={sectionContainerStyle}>
            <div style={{ ...sectionTitleStyle, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span>{lang.file_publish_label}</span>
              <RoundButton icon="arrow-right" title="View Filtered" btnColor="white" />
            </div>
            <hr style={dividerStyle} />
            <Grid data={publishStatusData} style={{ height: "220px", width: "100%", overflowY: "auto" }}>
              <Column field="platform" title="Platform" />
              <Column field="done" title="Done" />
              <Column field="error" title="Error" />
              <Column field="scheduled" title="Scheduled" />
            </Grid>
          </div>
        </div> */}
      </div>
      {
        showInfoPopup &&
        <BossDialog title={lang.history_dialog_header} onClose={() => setShowInfoPopup(false)} width={"700px"}>
          <Grid data={infoData} style={{ height: "300px" }} resizable={true}>
            <Column field="Timestamp" title={lang.time_stamp_label} cell={LocalDateTimeColumn} />
            <Column field="Message" title={lang.message_label} />
          </Grid>
        </BossDialog>
      }
      {showErrorResPreviewPopup && <AuditLogResponse details={detailsValue} oldValue={{}} newValue={errorResPreviewData} onClose={() => onCloseErrorResPreview()} />}

    </div>
    {showShowImportExportModuleInFullScreen &&
      <BossDialog title={lang.segment_details_label} onClose={() => setShowImportExportModuleInFullScreen(!showShowImportExportModuleInFullScreen)} width="80%">
        <div style={sectionContainerStyle}>
          <div style={{ ...sectionTitleStyle, display: "flex", alignItems: "center" }}>
            <span>{lang.import_export_module_wise_count_label}</span>
            <div style={{ marginLeft: "auto", display: "flex", gap: "8px" }}>
              <RoundButton icon="expand" title={lang.show_import_export_module_wise_full_screen_button_tooltip} onClick={() => setShowImportExportModuleInFullScreen(!showShowImportExportModuleInFullScreen)} />
              <RoundButton icon="arrow-right" title={`${lang.import_export_module_wise_count_label} View Filtered`} btnColor="white" onClick={() => navigate(`/home/logBrowser?Module=${IMPORT_EXPORT_MODULES.EPG_IMPORT}`)} />
            </div>
          </div>
          <hr style={dividerStyle} />
          <Grid data={importExportModuleWiseCount} style={{ height: "400px", width: "100%", overflowY: "auto" }}>
            <Column field="Module" title="Module" />
            <Column field="Success" title="Success" cell={NevigateLogBrowserCell} />
            <Column field="Failed" title="Failed" cell={NevigateLogBrowserCell} />
            <Column field="Processing" title="Processing" cell={NevigateLogBrowserCell} />
            <Column field="Validation Failed" title="Validation Failed" cell={NevigateLogBrowserCell} />
            <Column title="Action" cell={NevigateLogBrowserCell} />
          </Grid>
        </div>
      </BossDialog>}
  </>);
};


export default ProcessMonitoringDashboard